const PostAvatar = ({ src, className, ...others }) => {
  const defaultSrc = "/person.png";
  // const defaultSrc = "/person2.png";

  return (
    <div className={`relative rounded-full w-5 h-5 ${className}`}>

      <img
        src={src || defaultSrc}
        alt="avatar"
        className={`rounded-full w-full h-full object-cover`}
        {...others}
      />
    </div>
  );
};

export default PostAvatar;
